const cards = [
  {
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%20with%20elegant%20costumes%2C%20a%20couple%20in%20traditional%20wedding%20attire%20under%20red%20lanterns%2C%20warm%20romantic%20lighting%2C%20soft%20cinematic%20depth&width=400&height=280&seq=cards-pipi-01&orientation=landscape',
    tag: '热播',
    title: '长风渡',
    meta: '古装 · 爱情 · 40集全',
    desc: '白敬亭宋轶先婚后爱口碑爆棚',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Intense%20interrogation%20scene%20with%20two%20Chinese%20men%20in%20a%20dark%20room%2C%20one%20in%20police%20uniform%2C%20dramatic%20single%20light%20source%2C%20tense%20atmosphere%2C%20film%20noir%20style&width=400&height=280&seq=cards-pipi-02&orientation=landscape',
    tag: '必看',
    title: '狂飙',
    meta: '剧情 · 犯罪 · 39集全',
    desc: '张译张颂文演技封神现象级国产剧',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20celestial%20scene%20with%20floating%20islands%20and%20a%20woman%20in%20white%20flowing%20dress%20surrounded%20by%20magical%20glowing%20crystals%2C%20dreamy%20atmosphere%2C%20soft%20pastel%20colors&width=400&height=280&seq=cards-pipi-03&orientation=landscape',
    tag: '新剧',
    title: '星落凝成糖',
    meta: '仙侠 · 奇幻 · 40集全',
    desc: '陈星旭李兰迪演绎绝美仙侠虐恋',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Professional%20woman%20in%20sharp%20business%20suit%20standing%20in%20a%20modern%20TV%20news%20studio%20with%20cameras%20and%20screens%2C%20confident%20powerful%20pose%2C%20warm%20studio%20lighting&width=400&height=280&seq=cards-pipi-04&orientation=landscape',
    tag: '港剧',
    title: '新闻女王',
    meta: '都市 · 职场 · 26集全',
    desc: '佘诗曼回归TVB演绎新闻宫斗',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Peaceful%20countryside%20scene%20with%20Chinese%20wooden%20house%20and%20green%20fields%2C%20people%20cooking%20and%20laughing%20outdoors%2C%20warm%20sunset%20golden%20light%2C%20relaxing%20atmosphere&width=400&height=280&seq=cards-pipi-05&orientation=landscape',
    tag: '综艺',
    title: '向往的生活7',
    meta: '真人秀 · 慢综艺 · 14期',
    desc: '何炅黄磊温情收官治愈慢生活',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Disney%20animation%20style%20Mexican%20village%20with%20colorful%20marigold%20flowers%20and%20papel%20picado%20banners%2C%20a%20young%20boy%20with%20guitar%2C%20warm%20vibrant%20colors%2C%20magical%20glowing%20atmosphere&width=400&height=280&seq=cards-pipi-06&orientation=landscape',
    tag: '动画',
    title: '寻梦环游记',
    meta: '动画 · 音乐 · 家庭',
    desc: '皮克斯催泪神作温暖治愈人心',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20a%20polar%20bear%20on%20arctic%20ice%20under%20northern%20lights%2C%20breathtaking%20landscape%2C%20ultra%20high%20definition%20cinematic%20photography&width=400&height=280&seq=cards-pipi-07&orientation=landscape',
    tag: '纪录',
    title: '地球脉动3',
    meta: '纪录片 · 自然 · 8集',
    desc: 'BBC神级纪录片4K超清震撼视觉',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            编辑精心挑选，品质好剧一站推荐
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cards.map((card, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
                    card.tag === '热播' || card.tag === '新剧' || card.tag === '必看'
                      ? 'bg-primary-500 text-background-50'
                      : card.tag === '港剧' || card.tag === '动画'
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-secondary-500 text-background-50'
                  }`}>
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 whitespace-nowrap">{card.title}</h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{card.meta}</span>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}